/* Ship Saver Popup v2
 * Shows a modal when the cart contains only eligible lightweight products
 * under the flat-shipping weight threshold. Offers "add more" of the
 * current item (up to its per-product cap) plus a cross-sell grid of
 * other lightweight items that can be added without raising shipping.
 * Shows once per session. Per-product caps: exercise-band verified at 25
 * via live checkout test; others estimated from the 700g threshold.
 */
(function () {
  var cfg = window.ShipSaverConfig || {};
  if (!cfg.enabled) return;

  var products = cfg.products || [];
  if (!products.length) return;
  var byHandle = {};
  products.forEach(function (p) {
    byHandle[String(p.handle || '').toLowerCase()] = p;
  });

  var weightLimitG = parseInt(cfg.weightLimitG, 10) || 700;
  var SESSION_KEY = 'ship-saverPopup';
  var hasShownThisLoad = false; // in-memory: never show twice per page load

  function previewForced() {
    try {
      return new URLSearchParams(window.location.search).get('ship_saver_preview') === '1';
    } catch (e) {
      return false;
    }
  }

  function sessionState() {
    try {
      return sessionStorage.getItem(SESSION_KEY);
    } catch (e) {
      return null;
    }
  }

  function setSessionState(value) {
    try {
      if (value === null) sessionStorage.removeItem(SESSION_KEY);
      else sessionStorage.setItem(SESSION_KEY, value);
    } catch (e) {}
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function cartInfo(cart) {
    var eligibleWeightG = 0;
    var eligibleQty = 0;
    var totalQty = 0;
    var mainProduct = null; // first eligible product in cart
    var cartHandles = {};
    (cart.items || []).forEach(function (item) {
      var h = String(item.handle || '').toLowerCase();
      totalQty += item.quantity;
      var p = byHandle[h];
      if (p) {
        eligibleQty += item.quantity;
        eligibleWeightG += (item.quantity * (item.grams || 0));
        cartHandles[h] = true;
        if (!mainProduct) {
          mainProduct = {
            cfg: p,
            qty: item.quantity,
            title: p.title,
            variantId: item.variant_id
          };
        }
      }
    });
    return {
      eligibleQty: eligibleQty,
      totalQty: totalQty,
      eligibleWeightG: eligibleWeightG,
      mainProduct: mainProduct,
      cartHandles: cartHandles
    };
  }

  function shouldShow(info) {
    if (hasShownThisLoad) return false; // already shown this page load
    if (sessionState() && !previewForced()) return false;
    if (info.eligibleQty < 1) return false;
    if (info.totalQty !== info.eligibleQty) return false; // other products in cart
    if (info.eligibleWeightG >= weightLimitG) return false; // already at weight threshold
    return true;
  }

  function fill(template, values) {
    return String(template).replace(/\{(\w+)\}/g, function (m, key) {
      return values[key] != null ? values[key] : m;
    });
  }

  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return false;
    fetch('/cart?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('sections failed');
        return r.json();
      })
      .then(function (sections) {
        drawer.renderContents({ id: null, sections: sections });
      })
      .catch(function () {
        window.location.reload();
      });
    return true;
  }

  function quickAdd(variantId, qty, button) {
    button.disabled = true;
    var original = button.innerHTML;
    button.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        setSessionState('completed');
        hide();
        if (!refreshCartDrawer()) {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        button.disabled = false;
        button.innerHTML = original;
      });
  }

  var popup = null;

  function show(info) {
    popup = document.getElementById('ship-saver-popup');
    if (!popup) return;
    // Lock immediately: this popup shows exactly once.
    hasShownThisLoad = true;
    setSessionState('seen');
    var main = info.mainProduct;
    var cap = main.cfg.cap;

    // Body: "add more" wording when below cap, cross-sell-only wording at cap.
    var bodyEl = popup.querySelector('[data-ship-saver-body]');
    if (main.qty < cap) {
      bodyEl.textContent = fill(cfg.body, { qty: main.qty, product: main.title, cap: cap });
    } else {
      bodyEl.textContent = fill(cfg.bodyCrossSellOnly, { qty: main.qty, product: main.title });
    }

    // "Add more" buttons for the main product (only when below its cap).
    var actions = popup.querySelector('[data-ship-saver-actions]');
    actions.innerHTML = '';
    if (main.qty < cap) {
      var targets = [];
      var mid = Math.min(Math.ceil(cap / 2), cap);
      if (mid > main.qty) targets.push(mid);
      if (cap > main.qty && cap !== mid) targets.push(cap);
      targets.forEach(function (target) {
        var add = target - main.qty;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ship-saver__add';
        btn.textContent = fill(cfg.addLabel, { n: add, target: target });
        btn.addEventListener('click', function () {
          quickAdd(main.variantId, add, btn);
        });
        actions.appendChild(btn);
      });
    }

    // Cross-sell grid: other lightweight products not already in the cart.
    // Only show variants that fit the remaining weight budget, so the
    // "shipping stays the same" claim always holds.
    var crossSell = popup.querySelector('[data-ship-saver-cross-sell]');
    crossSell.innerHTML = '';
    var heading = popup.querySelector('[data-ship-saver-cross-sell-heading]');
    var budgetG = weightLimitG - info.eligibleWeightG;
    var others = products.filter(function (p) {
      if (info.cartHandles[String(p.handle).toLowerCase()]) return false;
      return p.variants.some(function (v) { return (v.w || 0) <= budgetG; });
    });
    if (others.length) {
      heading.hidden = false;
      heading.textContent = cfg.crossSellHeading;
      others.forEach(function (p) {
        var card = document.createElement('div');
        card.className = 'ship-saver__cross-sell-card';

        if (p.img) {
          var img = document.createElement('img');
          img.src = p.img;
          img.alt = p.title;
          img.loading = 'lazy';
          img.className = 'ship-saver__cross-sell-img';
          card.appendChild(img);
        }
        var t = document.createElement('div');
        t.className = 'ship-saver__cross-sell-title';
        t.textContent = p.title;
        card.appendChild(t);

        // Variant selector: only variants within the remaining weight budget.
        var fitting = p.variants.filter(function (v) { return (v.w || 0) <= budgetG; });
        var selectedVariantId = fitting[0].id;

        var pr = document.createElement('div');
        pr.className = 'ship-saver__cross-sell-price';
        pr.textContent = fitting[0].p;
        card.appendChild(pr);

        if (fitting.length > 1) {
          var sel = document.createElement('select');
          sel.className = 'ship-saver__cross-sell-variant';
          sel.setAttribute('aria-label', 'Choose a ' + p.title + ' option');
          fitting.forEach(function (v) {
            var opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.t + ' — ' + v.p;
            sel.appendChild(opt);
          });
          sel.addEventListener('change', function () {
            selectedVariantId = parseInt(sel.value, 10);
            var v = fitting.filter(function (x) { return x.id === selectedVariantId; })[0];
            if (v) pr.textContent = v.p;
          });
          card.appendChild(sel);
        } else {
          // Spacer keeps Add buttons aligned with multi-variant cards.
          var spacer = document.createElement('div');
          spacer.className = 'ship-saver__cross-sell-variant-spacer';
          spacer.setAttribute('aria-hidden', 'true');
          card.appendChild(spacer);
        }

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ship-saver__cross-sell-add';
        btn.textContent = cfg.crossSellAdd;
        btn.addEventListener('click', function () {
          quickAdd(selectedVariantId, 1, btn);
        });
        card.appendChild(btn);

        crossSell.appendChild(card);
      });
    } else {
      heading.hidden = true;
    }

    popup.hidden = false;
    document.body.classList.add('ship-saver-open');
  }

  function hide() {
    if (!popup) popup = document.getElementById('ship-saver-popup');
    if (popup) popup.hidden = true;
    document.body.classList.remove('ship-saver-open');
  }

  function bindDismiss() {
    var el = document.getElementById('ship-saver-popup');
    if (!el) return;
    el.querySelectorAll('[data-ship-saver-close]').forEach(function (node) {
      node.addEventListener('click', function () {
        setSessionState('dismissed');
        hide();
      });
    });
    el.querySelectorAll('[data-ship-saver-checkout]').forEach(function (node) {
      node.addEventListener('click', function () {
        setSessionState('dismissed');
        hide();
        window.location.href = '/checkout';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el && !el.hidden) {
        setSessionState('dismissed');
        hide();
      }
    });
  }

  var checkQueued = false;
  function maybeShow() {
    if (checkQueued) return;
    checkQueued = true;
    setTimeout(function () {
      checkQueued = false;
      fetchCart()
        .then(function (cart) {
          var info = cartInfo(cart);
          if (shouldShow(info)) show(info);
        })
        .catch(function () {});
    }, 600);
  }

  function watchCartSurfaces() {
    var drawerObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (
          m.target &&
          m.target.classList &&
          (m.target.classList.contains('active') || m.target.hasAttribute('open'))
        ) {
          maybeShow();
        }
      });
    });

    function attachDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
    }
    attachDrawer();

    var notifObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.target && m.target.classList && m.target.classList.contains('active')) maybeShow();
      });
    });
    var notif = document.querySelector('cart-notification');
    if (notif) notifObserver.observe(notif, { attributes: true, attributeFilter: ['class'] });

    if (window.location.pathname.replace(/\/$/, '') === '/cart') {
      var cartForm = document.querySelector('form[action="/cart"]');
      if (cartForm) {
        new MutationObserver(function () {
          maybeShow();
        }).observe(cartForm, { childList: true, subtree: true });
      }
    }
  }

  bindDismiss();
  watchCartSurfaces();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeShow);
  } else {
    maybeShow();
  }
})();
